'use strict';

const keyboardAccessibility = require('base/components/keyboardAccessibility');

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    const $html = $('<div>').append($.parseHTML(html));
    const $body = $html.find('.country-selector-content');
    const $footer = $html.find('.modal-footer').children();

    return { body: $body, footer: $footer };
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} selectedValueUrl - url to be used to retrieve the information
 * @param {string} countryUrl - url to be used to retrieve the country
 */
function fillModalElement(selectedValueUrl, countryUrl) {
    const $countrySelectorModal = $('#countrySelectorModal');
    const hasCountrySelector = $countrySelectorModal.find('.modal-body .country-selector-content').length > 0;
    if (hasCountrySelector) {
        setTimeout(function () {
            $countrySelectorModal.modal('show');
        }, 0);
    } else {
        $countrySelectorModal.spinner().start();
        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: function (data) {
                const parsedHtml = parseHtml(data);
                const $countrySelectorModalBody = $countrySelectorModal.find('.modal-body');
                const $countrySelectorModalHeader = $countrySelectorModal.find('.modal-header');
                $countrySelectorModalBody.empty();
                $countrySelectorModalBody.html(parsedHtml.body);
                $countrySelectorModalHeader.find('modal-footer').html(parsedHtml.footer);
                $countrySelectorModalHeader.find('.close').text(data.closeButtonText);
                $countrySelectorModalHeader.find('.modal-title').text($('.country-selector-modal-title').text());
                $countrySelectorModal.modal('show');
                $('body').trigger('countrySelectorModal:ready');
                $.spinner().stop();

                const $accordionHeader = $('.accordion-heading');
                const $accordionBody = $('.accordion-body');

                $accordionHeader.on('click', function (e) {
                    e.preventDefault();
                    let $this = $(this);

                    if ($this.hasClass('accordion-open')) {
                        $this.parent().find($accordionBody).slideUp();
                        $this.removeClass('accordion-open');
                    } else {
                        $accordionBody.slideUp();
                        $accordionHeader.removeClass('accordion-open');
                        $this.parent().find($accordionBody).slideToggle();
                        $this.addClass('accordion-open');
                    }
                });

                if (countryUrl) {
                    $('.confirmation-country-selector-link').attr('href', countryUrl);
                }
            },
            error: function () {
                $('#countrySelectorModal').spinner().stop();
            },
        });
    }
}

/**
 * show the country selector modal
 * @param {string} selectedValueUrl - url to be used to retrieve the information
 * @param {string} countryUrl - url to be used to retrieve the country
 * @param {boolean} showGeoModal - add or remove the geo class for the modal
 */
function showModal(selectedValueUrl, countryUrl, showGeoModal) {
    const $countrySelectorModal = $('#countrySelectorModal');
    fillModalElement(selectedValueUrl, countryUrl);
    if (showGeoModal && showGeoModal === true) {
        $countrySelectorModal.addClass('country-selector-modal-ip-geo');
    } else {
        $countrySelectorModal.removeClass('country-selector-modal-ip-geo');
    }
}

module.exports = function () {
    const $body = $('body');

    keyboardAccessibility(
        '.navbar-header .country-selector',
        {
            40: function ($countryOptions) {
                // down
                if ($(this).is(':focus')) {
                    $countryOptions.first().focus();
                } else {
                    $(':focus').next().focus();
                }
            },
            38: function ($countryOptions) {
                // up
                if ($countryOptions.first().is(':focus') || $(this).is(':focus')) {
                    $(this).focus();
                    $(this).removeClass('show');
                } else {
                    $(':focus').prev().focus();
                }
            },
            27: function () {
                // escape
                $(this).focus();
                $(this).removeClass('show').children('.dropdown-menu').removeClass('show');
            },
            9: function () {
                // tab
                $(this).removeClass('show').children('.dropdown-menu').removeClass('show');
            },
        },
        function () {
            if (!$(this).hasClass('show')) {
                $(this).addClass('show');
            }
            return $(this).find('.dropdown-country-selector').children('a');
        }
    );

    $body.on('click', '.js-country-selector', async function (e) {
        e.preventDefault();
        let selectedValueUrl = $(this).attr('href');
        const $countrySelectorModal = $('#countrySelectorModal');
        if ($countrySelectorModal.is(':visible')) {
            $countrySelectorModal.modal('hide');
            $countrySelectorModal.on('hidden.bs.modal', () => {
                showModal(selectedValueUrl, false);
            });
        } else {
            showModal(selectedValueUrl);
        }
    });

    $body.on('click', '.js-change-country-selector-confirmation:not(.active)', async function (e) {
        e.preventDefault();
        const $this = $(this);
        let selectedValueUrl = $this.attr('href');
        let countryUrl = $this.data('url');
        const $countrySelectorModal = $('#countrySelectorModal');
        $countrySelectorModal.modal('hide');
        $countrySelectorModal.on('hidden.bs.modal', () => {
            showModal(selectedValueUrl, countryUrl, true);
        });
    });

    $body.on('click', '#countrySelectorModal .close', function (e) {
        e.preventDefault();
        const $countrySelectorModal = $('#countrySelectorModal');
        $countrySelectorModal.modal('hide');
        $countrySelectorModal.off('hidden.bs.modal');
    });

    $('.navbar-header .country-selector').on('focusin', function () {
        $(this).addClass('show').children('.dropdown-menu').addClass('show');
    });

    const $changeCountrySelectorGeo = $('.change-country-selector-geo');
    if ($changeCountrySelectorGeo.length > 0) {
        let selectedValueUrl = $changeCountrySelectorGeo.data('url');
        showModal(selectedValueUrl);
        $('#countrySelectorModal').addClass('country-selector-modal-ip-geo');
    }

    $body.on('click', '.country-geoip__more-trigger', function (e) {
        e.preventDefault();
        $(this).closest('.country-selector-content').find('.country-geoip__more-countries').removeClass('d-none');
    });

    $body.on('click', '.js-change-country-selector', function () {
        const $this = $(this);
        const url = $this.data('href');
        const parentElement = $this.closest('.modal--country-selector__content');
        const updateCountryButton = parentElement.find('.update-country-selector-button');
        updateCountryButton.addClass('active-button').attr('data-url', url);
    });

    $body.on('click', '.link.active', function (e) {
        e.preventDefault();
        $('#countrySelectorModal').modal('hide');
    });
};
